import React from "react";
import Row from "../../widgets/Row";
import './About.css';
import bg from '../../images/about-cpct.jpg'

import logo2 from '../../images/logo.png';

export default function About() {

    const background = {
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    }

    return (
        <div className="mainContent">

            <br></br>

            <div className="backgroundImage" style={background}></div>
            <br></br>

            {/* About CPCT Section */}
            <section className="py-16 bg-dark max-w-5xl mx-auto  dark:from-gray-800 dark:to-gray-900">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">KUHUSU BARAZA LA CPCT</h1>
                        <p className="text-xl text-gray-700 dark:text-gray-300 max-w-3xl mx-auto">Baraza la Makanisa ya Kipentekoste Tanzania</p>
                    </div>

                    {/* History Section */}
                    <div className="bg-sky-800 text-white rounded-md shadow-lg p-8 mb-12">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                            <div>
                                <h2 className="text-3xl font-bold text-amber-400 dark:text-white mb-6">Historia ya CPCT</h2>
                                <p className="text-lg text-gray-100 dark:text-gray-100 mb-4">
                                    Upentekoste uliingia Tanganyika mwaka 1927. Kuanzia wakati huo hadi sasa kumekuwa na ongezeko la madhehebu ya kipentekoste. Madhehebu haya yamehubiri Injili na kutoa huduma za kijamii bila ubaguzi. Hata hivyo, changamoto kadhaa zimejitokeza za kuzaliwa kwa imani potofu, na hivyo kulihitajika chombo cha kulinda usahihi wa fundisho la imani ya Upentekoste na kuunganisha madhehebu ya kipentekoste.
                                </p>
                                <p className="text-lg text-gray-100 dark:text-gray-300 mb-4">

                                </p>
                                <p className="text-lg text-gray-100 dark:text-gray-300">
                                    Mwaka 1993 Baraza la Kipentekoste Tanzania, lililoitwa Pentecostal Council of Tanzania, kwa kifupi PCT, liliundwa na kusajiliwa. Mwenyekiti wa kwanza alikuwa Askofu Dkt. Sylvester Gamanywa wa Wapo Mission International (WMI) aliyehudumu hadi mwaka 2009 wakati Askofu David Batenzi wa Kanisa la The Free Pentecostal Church of Tanzania (FPCT) alipokuwa Mwenyekiti hadi 2021. Mwaka 2021 Askofu Peter Konki wa kanisa la Elim Pentekoste alikuwa mwenyekiti hadi mwaka 2023 ambapo Askofu Dkt. Barnabas W. Mtokambali wa Tanzania Assemblies of God (TAG) alichaguliwa.
                                </p>
                            </div>

                            <div>
                                <p className="text-lg text-gray-100 dark:text-gray-100 mb-4">
                                    Kwa kuwa wanachama wa PCT ni madhehebu ya kipentekoste, mwaka 2013 ilionekana umuhimu wa kuimarisha dhana ya uanachama wa madhehebu na huduma za kipentekoste kwa kuzingatia kuwa madhehebu yanaundwa na makanisa. Kwa sababu hiyo, ilikuwa ni lazima kubadilisha jina kutoka Baraza la Kipentekoste Tanzania, yaani PCT, kuwa Baraza la Makanisa ya Kipentekoste Tanzania, yaani “The Council of Pentecostal Churches of Tanzania”, kifupi “CPCT”.
                                </p>

                                <p className="text-lg text-gray-100 dark:text-gray-300 mb-4">
                                    Pamoja na kuboresha dhana ya madhehebu na makanisa yake, lengo la msingi lilibaki kuwaunganisha wapentekoste nchini kupitia madhehebu yao, ili kushirikiana kwa pamoja kulinda imani ya upentekoste, kukabiliana na changamoto za imani potofu, na kuakisi sura sahihi ya mwili wa Kristo.
                                </p>

                                <p className="text-lg text-gray-100 dark:text-gray-300">
                                    CPCT ni ushirika wa kibaraza wa madhehebu na huduma huru za kipentekoste ambapo uanachama wake ni wa uwakilishi. Maaskofu na wakuu wa huduma sio wanachama binafsi bali ni wawakilishi wa madhehebu na huduma wanazosimamia. Aidha, uendeshaji wa CPCT hauingilii shughuli za wanachama wake bali ni fungamano la kisheria linalotoa fursa ya kuwa na sauti moja ya kuujenga, kuulinda, na kuutetea Upentekoste sawa sawa na fundisho la Biblia.
                                </p>
                            </div>
                        </div>
                    </div>



                    {/* Core Values */}
                    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Maadili ya Msingi</h2>

                        <div className="md:flex gap-6 text-lg">
                            <div className={'flex flex-col flex-1 gap-3'}>
                                <div className="flex items-start gap-4 rounded-lg dark:bg-blue-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-blue-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-blue-400 font-bold">i</span>
                                    </div>
                                    <p className="">Uaminifu kwa Biblia ambayo ni Neno la Mungu lisiloghoshiwa</p>
                                </div>
                                <div className="flex items-start gap-4 rounded-lg  dark:bg-green-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-green-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-green-400 font-bold">ii</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Utakatifu na Uadilifu</p>
                                </div>
                                <div className="flex items-start gap-4  rounded-lg  dark:bg-purple-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-purple-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-purple-400 font-bold">iii</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Kicho kwa Roho Mtakatifu</p>
                                </div>
                                <div className="flex items-start gap-4 rounded-lg  dark:bg-orange-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-orange-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-orange-400 font-bold">iv</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Maisha ya Maombi</p>
                                </div>
                            </div>

                            <div className={'flex flex-col flex-1 gap-3'}>
                                <div className="flex items-start gap-4 rounded-lg dark:bg-blue-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-blue-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-blue-400 font-bold">v</span>
                                    </div>
                                    <p className="">Umisheni na Uinjilisti</p>
                                </div>
                                <div className="flex items-start gap-4 rounded-lg  dark:bg-green-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-green-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-green-400 font-bold">vi</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Kufikiri, Kubuni, na Kupanga
                                        Kimkakati</p>
                                </div>
                                <div className="flex items-start gap-4  rounded-lg  dark:bg-purple-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-orange-100 dark:bg-purple-800 rounded-full flex items-center justify-center">
                                        <span className="text-orange-700 dark:text-purple-400 font-bold">vii</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Uongozi wa Kiutumishi na
                                        Kuachilia kizazi kijacho kutimiza wito wao</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Ukiri wa Umoja */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12 text-lg">
                        <div className="bg-white dark:from-purple-900/20 dark:to-pink-900/20 rounded-2xl shadow-lg p-8">
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Ukiri wa Umoja</h3>
                            <p className="text-gray-700 dark:text-gray-300 italic">
                                "Palipo na umoja, BWANA huamuru baraka" (Zaburi 133:3)
                            </p>
                        </div>

                        <div className="bg-white dark:from-purple-900/20 dark:to-pink-900/20 rounded-2xl shadow-lg p-8">
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Mkakati</h3>
                            <p className="text-gray-700 dark:text-gray-300">
                                Baraza litazingatia Malengo Mkakati yatakayobuniwa na Kamati Tendaji, kuridhiwa na Baraza la Maaskofu na kuidhinishwa na Mkutano Mkuu.
                            </p>
                        </div>
                    </div>



                    {/* Makusudi ya Baraza */}
                    <div className="bg-amber-100 text-lg dark:bg-gray-800 rounded-2xl shadow-lg p-8">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">Makusudi ya Baraza</h2>
                        <div className="gap-6 md:flex">
                            <div className={"flex flex-1 flex-col gap-4"}>
                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">i</span>
                                    </div>
                                    <p>Kujenga Baraza la kipentekoste lenye uwezo na uzoefu wa kiroho na kihuduma
                                        ili kuleta mabadiliko na mguso chanya kiroho, kijamii na kiuchumi, kwenye
                                        kanisa la Mungu nchini, jamii ya Tanzania na kimataifa.</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">ii</span>
                                    </div>
                                    <p>Kukuza, kuchochea, na kulinda umoja na mafundisho sahihi ya imani ya
                                        Upentekoste tukiongozwa daima na Biblia na hivyo kusababisha uamsho mkubwa,
                                        wenye udhihirisho wa matendo makuu ya Mungu katika nchi.</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100 ">iii</span>
                                    </div>
                                    <p>Kukuza upatikanaji wa huduma za msingi za jamii mfano elimu, afya, maji na
                                        usafi wa mazingira na nyingine, ili kuchochea maadili mema, na kutoa mchango
                                        katika ukuaji wa uchumi.</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">iv</span>
                                    </div>
                                    <p>Kuendesha makongamano ya pamoja kitaifa na kimataifa kuhusu maombi, kusifu na
                                        kuabudu, umwagiko wa Roho Mtakatifu, mafundisho na huduma za kiroho kwa
                                        makundi mbalimbali.</p>
                                </div>
                            </div>

                            <div className={"flex flex-1 flex-col gap-4"}>
                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">v</span>
                                    </div>
                                    <p>Kuhakiki, kuweka na kusimamia utaratibu wa mahusiano na ushirikiano na
                                        mashirika mengine ya kipentekoste kitaifa na kimataifa. Kuhimiza, kuchochea,
                                        kusaidia kukua kwa kanisa kiidadi, kijiografia na kiufanisi kupitia
                                        umisheni, mikutano mikubwa ya hadhara na upandaji wa makanisa ndani na nje
                                        ya nchi kwa juhudi za pamoja miongoni mwa wanachama. </p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">vi</span>
                                    </div>
                                    <p>Kumiliki ardhi, majengo, mali, na rasilimali nyingine kwa ajili ya kuwezesha
                                        Baraza kufikia malengo yake.</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">vii</span>
                                    </div>
                                    <p>Kuhimiza na kujenga uwezo wa matumizi sahihi na umiliki wa Teknolojia ya
                                        Habari na Mawasiliano, yaani TEHAMA kwa wanachama.</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100 ">viii</span>
                                    </div>
                                    <p>Kushirikiana na mashirika, Serikali, na vyombo vya umma katika kutimiza
                                        makusudi na malengo ya Baraza pasipo kuathiri imani ya Upentekoste.</p>
                                </div>
                            </div>


                        </div>
                    </div>


                    {/* Tafsiri ya Upentekoste */}
                    <div className="bg-white dark:bg-gray-800 mt-8 rounded-2xl shadow-lg p-8 mb-12 text-lg">
                        <h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Tafsiri ya Upentekoste</h2>
                        <span>
                                Upentekoste hutafsiriwa kwa kuishi na kudhihirishwa kwa mwenendo na sio imani tu, bali uhalisia wa maisha ya mwamini <i>(Efeso 4:1-3; Yakobo 2:17-26)</i> katika mambo manne yafuatayo yanayodhihirishwa kwa:
                            </span>
                        <br></br>
                        <br></br>

                        <div className="md:flex gap-6">
                            <div className={'flex flex-col flex-1 gap-3'}>
                                <div className="flex items-start gap-4 rounded-lg dark:bg-blue-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-blue-800 rounded-full flex items-center justify-center">
                                        <span className="text-white dark:text-blue-400 font-bold">i</span>
                                    </div>
                                    <p className="">Kuokoka, yaani, kuzaliwa mara ya pili na kubatizwa katika maji mengi. (Marko 16:16; Matendo 2:38)</p>
                                </div>
                                <div className="flex items-start gap-4 rounded-lg  dark:bg-green-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-green-800 rounded-full flex items-center justify-center">
                                        <span className="text-white dark:text-green-400 font-bold">ii</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Ujazo wa Roho Mtakatifu, jambo lililo tofauti na tukio la kuokoka ambapo mtu hujazwa nguvu za Roho Mtakatifu baada ya kuokoka. (Matendo 2:4; 10:44-46)</p>
                                </div>
                            </div>

                            <div className={'flex flex-col flex-1 gap-3 mt-4 md:mt-auto'}>
                                <div className="flex items-start gap-4  rounded-lg  dark:bg-purple-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-purple-800 rounded-full flex items-center justify-center">
                                        <span className="text-white dark:text-purple-400 font-bold">iii</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Kunena kwa lugha mpya kama ishara ya awali na endelevu ya kujazwa Roho Mtakatifu. (Matendo 2:4; 10:44-46); na</p>
                                </div>
                                <div className="flex items-start gap-4 rounded-lg  dark:bg-orange-900/20">
                                    <div
                                        className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-orange-800 rounded-full flex items-center justify-center">
                                        <span className="text-white dark:text-orange-400 font-bold">iv</span>
                                    </div>
                                    <p className="text-gray-700 dark:text-gray-300">Kutambua kuwa, ujazo wa Roho Mtakatifu ni kwa ajili ya kutimiza Agizo Kuu na sio kwa ajili ya utakaso peke yake. (Mdo 1:8; Tito 3:4-5).</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Statement of Faith */}
                    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">Tamko la Imani</h2>

                        <div className="gap-6 md:flex">
                            <div className={"flex flex-1 flex-col gap-4"}>
                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">i</span>
                                    </div>
                                    <p>Tunaamini kuwa Biblia ni Neno la Mungu, limevuviwa na Roho Mtakatifu, halina makosa, na ni lenye mamlaka ya Mungu ya mwisho. (2Timotheo 3:16; 2Petro 1:20-21).</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">ii</span>
                                    </div>
                                    <p>Tunaamini kuwa kuna Mungu mmoja (Kumb. 6:4; 1Korintho 8:4), aishiye milele katika nafsi tatu, yaani; Baba, Mwana, na Roho Mtakatifu. (Mathayo 28:19; 2Korintho 13:13).</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100 ">iii</span>
                                    </div>
                                    <p>Tunaamini kuhusu Uungu wa BWANA Yesu Kristo, Uanadamu wake, kuzaliwa na Bikira Mariamu, maisha yake yasiyokuwa na dhambi, miujiza, kifo chake cha kidhabihu na damu yake iokoayo, ufufuko wake wa mwili, kupaa kwake na kuketi katika mkono wa kuume wa Mungu Baba na kuja kwake mara ya pili kwa nguvu na utukufu. (Isaya 9:6; 1Thesalonike 4:15-17; 1Timotheo 2:5).</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">iv</span>
                                    </div>
                                    <p>Tunaamini kuwa wokovu wa wanadamu waliopotea na kuzaliwa upya kunakofanywa na Roho Mtakatifu kwa njia ya imani katika Yesu Kristo ni jambo la lazima kwa uzima wa milele. (Tito 3:4-6, Matendo 4:12). </p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100 ">v</span>
                                    </div>
                                    <p>v)Tunaamini juu ya ubatizo wa Roho Mtakatifu unaoashiriwa kwa kunena kwa lugha mpya kama mtu ajaliwavyo na Roho Mtakatifu kulingana na Matendo 2:4 na Matendo 10:44-46, utendaji wa karama za Roho Mtakatifu, na huduma zake. </p>
                                </div>
                            </div>

                            <div className={"flex flex-1 flex-col gap-4"}>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">vi</span>
                                    </div>
                                    <p>Tunaamini kuhusu huduma ya Roho Mtakatifu ndani ya mwamini imwezeshayo kuishi maisha ya uchaji, haki, na utakatifu wa kweli. (Tito 3:4-5; Efeso 4:24). </p>
                                </div>
                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">vii</span>
                                    </div>
                                    <p>Tunaamini kuwa ndoa ni muungano kati ya mwanamume mmoja na mwanamke mmoja kulingana na mpango wa Mungu wa awali kwa mwanadamu, uliokusudiwa kudumu kwa maisha yote ya wanandoa duniani. (Mwanzo 2:18, 21-25; Marko 10:7-9). </p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">viii</span>
                                    </div>
                                    <p>Tunaamini kuhusu ufufuo wa wenye haki na wenye dhambi - wenye haki ufufuo wa uzima wa milele na wenye dhambi ufufuo wa hukumu ya milele. (Mathayo 25:46).</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100">ix</span>
                                    </div>
                                    <p>Tunaamini katika Kanisa la Yesu Kristo na umoja wa waamini. (Mathayo 16:18; Matendo 2:42-47; Rumi12:5; Kolosai 1:18). </p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100 ">x</span>
                                    </div>
                                    <p>Tunaamini kuiweka imani ya Upentekoste katika u-Kristo kwenye utendaji wa maisha ya kila siku, na hitaji la kuwahudumia watu katika maeneo yote ya maisha ambayo yanajumuisha siyo mambo ya kiroho tu, bali pia, kijamii, kisiasa na kimwili. (Mathayo 5:13-16).</p>
                                </div>

                                <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                    <div
                                        className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                        <span className="text-amber-100 ">xi</span>
                                    </div>
                                    <p>Tunaamini juu ya Agizo Kuu la Bwana Yesu, la kuipeleka Injili kamili kwa ulimwengu wote linalojumuisha ubatizo kwenye maji kwa kuzamisha na kuwafanya kuwa wanafunzi wa Yesu. (Mathayo 28:18-20, Marko 16:15).</p>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

function Contact(props) {
    return (
        <div className="contactRow">
            <div className='contactIcon'>{props.icon}</div>
            <span className='contacts'>{props.contacts}</span>
        </div>
    )
}